var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEsign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9479 6.03916C18.9381 4.68675 18.6459 2.78667 17.2952 1.79521C15.9445 0.803742 14.0469 1.09634 13.0567 2.44874M17.9479 6.03916L13.0567 2.44874M17.9479 6.03916L16.3183 8.32426M13.0567 2.44874L11.4963 4.63689M11.4963 4.63689L3.34841 16.0624C3.1487 16.3424 3.02452 16.6693 2.98787 17.0115L2.78709 18.8862C2.62942 20.3584 4.06797 21.4868 5.45783 20.9812L7.35183 20.2921C7.73163 20.1539 8.06064 19.9037 8.29544 19.5744L16.3183 8.32426M11.4963 4.63689L16.3183 8.32426",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85352 22.0381C13.7969 22.0381 19.3734 22.7359 19.3734 18.5488C19.3734 22.7359 25.5349 22.7359 25.5349 18.5488C25.5349 19.9445 25.7814 22.0381 27.9996 22.0381",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsign);
export default __webpack_public_path__ + "static/media/esign.8918a70f.svg";
export { ForwardRef as ReactComponent };